import { ApiRequestGateway } from "../ApiRequestGateway";
import { RequestServiceFactory } from "../RequestService";
import { GlobalConfig } from "../configuration";
import { AjaxService } from "sb-helpers";
class ApiRequestGatewayFactory {
    static getApiRequestGateway() {
        if (!ApiRequestGatewayFactory.gateway) {
            ApiRequestGatewayFactory.gateway = new ApiRequestGateway(RequestServiceFactory.getRequestService(GlobalConfig.applicationType, GlobalConfig.apiVersion, GlobalConfig.anonymousApiUrl, GlobalConfig.siteID, GlobalConfig.operatorAuthTokenId, new AjaxService()));
        }
        return ApiRequestGatewayFactory.gateway;
    }
}
export const apiRequestGateway = ApiRequestGatewayFactory.getApiRequestGateway;
//# sourceMappingURL=ApiRequestGatewayFactory.js.map